import { styled, alpha } from "@mui/material/styles";
import { TextField } from "@mui/material";

interface StyledTextFieldProps {
  height?: number;
}
const INPUT_HEIGHT = 42;

const StyledTextField = styled(TextField)<StyledTextFieldProps>(
  ({ theme, height }) => ({
    "& .MuiInputBase-root": {
      backgroundColor: theme.palette.background.paper,
      borderRadius: 4,
      fontSize: 14,
      height: `${height ?? INPUT_HEIGHT}px`,
      transition: theme.transitions.create(["border-color", "box-shadow"]),
    },

    "& .MuiOutlinedInput-notchedOutline": {
      border: `2px solid ${theme.palette.secondary.main}`,
    },

    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: `2px solid ${theme.palette.secondary.main}`,
    },

    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
    },

    "& label.Mui-focused": {
      color: "green",
    },

    "& .MuiFilledInput-root": {
      backgroundColor: theme.palette.background.paper,
      "&:before, &:after": {
        borderBottom: `2px solid ${theme.palette.secondary.main}`,
      },
      "&:hover:before": {
        borderBottom: `2px solid ${theme.palette.primary.main}`,
      },
      "&.Mui-focused:after": {
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      },
    },

    "& .MuiInput-root": {
      "&:before": {
        borderBottom: `2px solid ${theme.palette.secondary.main}`,
      },
      "&:hover:before": {
        borderBottom: `2px solid ${theme.palette.primary.main}`,
      },
      "&.Mui-focused:after": {
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      },
    },
  }),
);

export default StyledTextField;
